<template>
  <div style="clear: both;">
      <v-container>
        <v-row>
          <v-col cols="12">
            <span class="screenHeading">Select IT Support</span>
          </v-col>
        </v-row>
        <v-form autocomplete="off">
          <v-row class="mb-2">
            <v-col cols="12" sm="6">
              <people-picker-ms
                label="IT Support"
                v-model="itSupport"
                title="IT Support"
                @update="args => this.handleUpdate(args)"
              ></people-picker-ms>
            </v-col>
          </v-row>
          <v-btn color="success" class="me-2" @click="sendData">Save</v-btn>
          <v-btn color="info" @click="confirm = true">Cancel</v-btn>
        </v-form>
      </v-container>
      <v-dialog persistent v-model="confirm" max-width="500">
        <v-card>
          <v-toolbar elevation="1" color="warning" density="compact">
            <v-spacer></v-spacer><v-icon class="me-5" color="black">mdi-bell-alert-outline</v-icon>
          </v-toolbar>
          <v-card-text class="text-h5">Confirm cancel</v-card-text>
          <v-card-text>Are you sure you want to cancel your change?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text="text" @click="cancel()">Yes</v-btn>
            <v-btn color="info" text="text" @click="confirm = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCAdminService from '@/services/admin.service'
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import Toaster from '@/components/Toaster'
export default {
  name: 'ITSupport',
  data: () => ({
    // people pickers
    isSaving: false,
    confirm: false,
    itSupport: [],
    snackbar: {
      show: false,
      color: '',
      mode: '',
      successTimeout: 2000,
      timeout: 6000,
      text: '',
      icon: null,
      closeIcon: 'close'
    }
  }),
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    formData: {}
  },
  methods: {
    handleUpdate: function(userAction) {
      this.itSupport = userAction.Users
    },
    cancel() {
      this.getData()
      this.confirm = false
    },
    sendData: function() {
      if (!this.isSaving) {
        this.isSaving = true
        MOCAdminService.updateITSupport(this.itSupport)
          .then(() => {
            this.$refs.toaster.pop('success', 'Success')
            // TODO: deterimine if we need to do anything here
          })
          .catch(e => {
            // TODO: deterimine if we need to do anything here
            if (e.response.status === 403) {
              this.$refs.toaster.pop('error', 'You are unauthorized to update the IT Support list')
            } else {
              this.$refs.toaster.pop('error', 'Error while saving')
            }
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    getData: function() {
      MOCAdminService.getITSupport()
        .then(u => {
          this.itSupport = u.itSupport
        })
        .catch(e => {
          // TODO: deterimine if we need to do anything here
          if (e.response.status === 403) {
            this.$refs.toaster.pop(
              'error',
              'You are unauthorized to view the IT Support list.  Please contact the Process Manager(s)'
            )
          } else {
            this.$refs.toaster.pop('error', 'Error while retrieving IT Support list')
          }
        })
    }
  },
  components: {
    PeoplePickerMs,
    Toaster
  },
  computed: {},
  created() {
    this.getData()
  }
}
</script>

<style scoped></style>
